import React from 'react';
import AnalysisTablesShared from './AnalysisTablesShared';

export default function OrderCountAnalysis() {
  return <AnalysisTablesShared mode="count" />;
}